export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">编辑团队为你甄选的优质内容，每一部都值得一看</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">

          {/* Card 1 */}
          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 cursor-pointer">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20detective%20in%20rainy%20city%20alley%20at%20night%2C%20film%20noir%20style%2C%20dramatic%20shadows%20and%20neon%20reflections%2C%20warm%20amber%20and%20cool%20contrast%2C%20no%20text&width=640&height=400&seq=cards-recommend-01&orientation=landscape"
                alt="暗夜追踪者"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">悬疑</span>
                <span className="text-xs text-foreground-400">豆瓣 9.2</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">暗夜追踪者 · 第三季</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">一桩离奇命案揭开城市暗面，退休刑警与新锐侦探联手追凶，层层反转。</p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-accent-300/60 transition-all duration-300 cursor-pointer">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20family%20dinner%20scene%20in%20traditional%20Chinese%20home%2C%20soft%20evening%20light%2C%20nostalgic%20atmosphere%2C%20lifestyle%20cinematography%2C%20no%20text&width=640&height=400&seq=cards-recommend-02&orientation=landscape"
                alt="向阳人家"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-medium text-accent-500 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">家庭</span>
                <span className="text-xs text-foreground-400">豆瓣 8.8</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">向阳人家</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">三代同堂的温馨故事，平凡生活中藏着最动人的爱与成长。</p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-secondary-300/60 transition-all duration-300 cursor-pointer">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20city%20with%20flying%20vehicles%20and%20holograms%2C%20cyberpunk%20aesthetic%2C%20warm%20neon%20lighting%2C%20cinematic%20wide%20shot%2C%20no%20text&width=640&height=400&seq=cards-recommend-03&orientation=landscape"
                alt="星际迷航：新纪元"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-medium text-secondary-500 bg-secondary-100 px-2 py-0.5 rounded-full whitespace-nowrap">科幻</span>
                <span className="text-xs text-foreground-400">豆瓣 8.5</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">星际迷航：新纪元</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">人类首支深空探索队遭遇未知文明，宇宙尺度的冒险与抉择震撼人心。</p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 cursor-pointer">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20elegant%20costumes%2C%20warm%20candlelight%2C%20historical%20drama%20atmosphere%2C%20rich%20textures%2C%20no%20text&width=640&height=400&seq=cards-recommend-04&orientation=landscape"
                alt="长安十二时辰"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">古装</span>
                <span className="text-xs text-foreground-400">豆瓣 9.1</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">长安十二时辰</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">盛世大唐暗流涌动，二十四小时内拯救长安的惊险故事，服化道精致绝伦。</p>
            </div>
          </div>

          {/* Card 5 */}
          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-accent-300/60 transition-all duration-300 cursor-pointer">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cute%20animated%20characters%20in%20magical%20forest%20with%20glowing%20fireflies%2C%20warm%20fantasy%20atmosphere%2C%20whimsical%20color%20palette%2C%20animation%20film%20style%2C%20no%20text&width=640&height=400&seq=cards-recommend-05&orientation=landscape"
                alt="星灵奇旅"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-medium text-accent-500 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">动画</span>
                <span className="text-xs text-foreground-400">豆瓣 8.9</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">星灵奇旅</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">少女与星灵在异世界的奇幻冒险，画面美到每一帧都可以当壁纸的治愈之作。</p>
            </div>
          </div>

          {/* Card 6 */}
          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-secondary-300/60 transition-all duration-300 cursor-pointer">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Bustling%20Korean%20street%20food%20market%20at%20night%20with%20warm%20lanterns%2C%20cozy%20romantic%20atmosphere%2C%20lifestyle%20cinematography%2C%20no%20text&width=640&height=400&seq=cards-recommend-06&orientation=landscape"
                alt="首尔夜食记"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-medium text-secondary-500 bg-secondary-100 px-2 py-0.5 rounded-full whitespace-nowrap">美食</span>
                <span className="text-xs text-foreground-400">豆瓣 8.3</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">首尔夜食记</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">跟着美食博主逛遍首尔深夜食堂，每一集都让人馋到想立刻订机票。</p>
            </div>
          </div>

          {/* Card 7 */}
          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 cursor-pointer">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Intense%20sports%20competition%20scene%20on%20basketball%20court%20with%20dramatic%20lighting%2C%20athletic%20energy%2C%20cinematic%20sports%20photography%2C%20no%20text&width=640&height=400&seq=cards-recommend-07&orientation=landscape"
                alt="冠军之路"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">运动</span>
                <span className="text-xs text-foreground-400">豆瓣 8.6</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">冠军之路</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">小镇少年逆袭成为全国冠军的真实故事，燃到热泪盈眶的体育励志大片。</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}